/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zippy_Actual_Marmot_PoutInputs */

const fr_zippy_actual_marmot_pout = /** @type {(inputs: Zippy_Actual_Marmot_PoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EMOM de 12 Minutes ...`)
};

/**

* @param {Zippy_Actual_Marmot_PoutInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zippy_actual_marmot_pout = /** @type {((inputs?: Zippy_Actual_Marmot_PoutInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zippy_Actual_Marmot_PoutInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zippy_actual_marmot_pout(inputs)
});